import { createActions, handleActions } from 'redux-actions'
import Immutable, { List, Map } from 'immutable'
import fetch from '@request/fetch'

const SEARCH_USER_MONITORS = 'SEARCH_USER_MONITORS' // 获取监控详情列表
const GET_MONITOR_REASONS = 'GET_MONITOR_REASONS' // 获取全部监控理由
const POST_USER_MONITORS = 'POST_USER_MONITORS' // 新增监控用户
const UPDATE_AUDIT_RESULT = 'UPDATE_AUDIT_RESULT' // 修改审核状态
const REMARK_ADD = 'REMARK_ADD' // 新增备注
const SYNC_MONITOR_DATA = 'SYNC_MONITOR_DATA' // 同步监控数据
const STOP_MONITOR = 'STOP_MONITOR' // 停止监控
const SEARCH_MONITOR_REMARK = 'SEARCH_MONITOR_REMARK' // 查询备注信息

const defaultState = Immutable.fromJS({
  monitorList: {
    list: [],
    total: 0
  },
  riskRemarkList: {
    list: [],
    total: 0
  }
})

export const monitorAction = createActions({
  SEARCH_USER_MONITORS: async params => {
    const result = await fetch.post(`/monitor/configs/searchUserMonitors`, params)
    return result
  },
  GET_MONITOR_REASONS: async params => {
    const result = await fetch.get(`/monitor/configs/monitorReasons`)
    return result
  },
  POST_USER_MONITORS: async params => {
    const result = await fetch.post(`/monitor/configs/postUserMonitors`, params)
    return result
  },
  UPDATE_AUDIT_RESULT: async params => {
    const result = await fetch.post('/monitor/configs/updateAuditResult', params)
    return result
  },
  REMOVE_MONITOR: async params => {
    const result = await fetch.post('/monitor/configs/removeMonitor', params)
    return result
  },
  SYNC_MONITOR_DATA: async params => {
    const result = await fetch.post('/monitor/configs/syncMonitorData', params, {}, 30000)
    return result
  },
  STOP_MONITOR: async params => {
    const result = await fetch.post('/monitor/configs/stopMonitor', params)
    return result
  },
  SEARCH_MONITOR_REMARK: async params => {
    const result = await fetch.post(`/monitor/configs/searchConfigRemarks`, params)
    return result
  },
  PATCH_MONITOR_REMARK: async params => {
    const result = await fetch.post(`/monitor/configs/patchConfigRemarks`, params)
    return result
  },
  DELETE_MONITOR_REMARK: async params => {
    const result = await fetch.post(`/monitor/configs/deleteRemark`, params)
    return result
  }
})

const reducer = handleActions(
  {
    [SEARCH_USER_MONITORS]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'monitorList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    },
    [GET_MONITOR_REASONS]: (state, action) => {
      let curState = state
      const data = action.payload
      const monitorReasonsMap = {}

      data.forEach((reason) => {
        monitorReasonsMap[reason.type] = reason.title
      })
      curState = curState.set('monitorReasonsMap', monitorReasonsMap)
      return curState
    },
    [SEARCH_MONITOR_REMARK]: (state, action) => {
      let curState = state
      const { totalCount, records } = action.payload
      curState = curState.set(
        'riskRemarkList',
        new Map({
          list: new List(records),
          total: totalCount
        })
      )
      return curState
    }
  },
  defaultState
)

export default reducer
